// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"r4-z","dimensionLabel":"s4-z","styleChooserControlWrapper":"t4-z","styleChooserControl":"u4-z","disabled":"v4-z","giftCard":"w4-z","styleChooserText":"x4-z"};